module.exports = __webpack_public_path__ + "img/21.28d443e0.svg";